// Vars //
var $body = jQuery('body');

function back_to_top() {
    var body = jQuery("body");
    jQuery(window).scroll(function () {
        var scroll = jQuery(window).scrollTop();

        if (scroll >= 100) {
            body.addClass("show-scroll-to-top");
        } else {
            body.removeClass("show-scroll-to-top");
        }
    });
}

/**
 * 
 * @param {string} selectClass
 *      ~ Input Field Class 
 * 
 */
function styled_select_2(selectClass) {
    jQuery(selectClass).each(function() {
        var selectBox = jQuery(this);
        
        var selectBoxID = selectBox.attr('id');
        var selectBoxContainer = selectBoxID + '_container';

        selectBox.parent().attr('id', selectBoxContainer);

        selectBox.select2({
            minimumResultsForSearch: Infinity,
            dropdownParent: jQuery('#' + selectBoxContainer),
        });
    });
}

/**
 * 
 * Header Hero Slider
 * 
 */
function header_hero_slider() {
    var $sliderContainer = jQuery('.slider-container');

    $sliderContainer.each(function () {
        var $container = jQuery(this),
            $slider = $container.find('.slider'),
            $controls = $container.find('.slider-controls'),
            $dots = $container.find('.slider-dots'),
            dots = false,
            infinite = true,
            slidesToShow = 1,
            slidesToScroll = 1,
            arrows = false,
            autoplay = false
        ;

        // Arrows //
        if ($container.hasClass('arrows')) {
            arrows = true;
        }

        // Dots //
        if ($container.hasClass('dots')) {
            dots = true;
        }

        // Autoplay //
        if ($container.hasClass('auto')) {
            autoplay = true;
        }

        $slider.not('.slick-initialized').slick({
            slidesToShow: slidesToShow,
            slidesToScroll: slidesToScroll,
            dots: dots,
            arrows: arrows,
            autoplay: autoplay,
            infinite: infinite,
            appendDots: $dots,
            appendArrows: $controls,
            autoplaySpeed: 5000,
            prevArrow:
                '<a class="slick-prev"><span class="icon"><i class="fal fa-arrow-left"></i></span></a>',
            nextArrow:
                '<a class="slick-next"><span class="icon"><i class="fal fa-arrow-right"></i></span></a>'
        });
    });
}

/**
 * 
 * Logo Section Slider
 * 
 */
function logo_section_slider() {
    var $sliderContainer = jQuery('.logo-slider-container');

    $sliderContainer.each(function () {
        var $container = jQuery(this),
            $slider = $container.find('.slider'),
            $controls = $container.find('.slider-controls'),
            $dots = $container.find('.slider-dots'),
            dots = false,
            infinite = true,
            slidesToShow = 3,
            slidesToScroll = 1,
            arrows = false,
            autoplay = false
        ;

        // Arrows //
        if ($container.hasClass('arrows')) {
            arrows = true;
        }

        // Dots //
        if ($container.hasClass('dots')) {
            dots = true;
        }

        // Autoplay //
        if ($container.hasClass('auto')) {
            autoplay = true;
        }

        $slider.not('.slick-initialized').slick({
            slidesToShow: slidesToShow,
            slidesToScroll: slidesToScroll,
            dots: dots,
            arrows: arrows,
            autoplay: autoplay,
            infinite: infinite,
            appendDots: $dots,
            appendArrows: $controls,
            autoplaySpeed: 5000,
            prevArrow:
                '<a class="slick-prev"><span class="icon"><i class="fal fa-chevron-left"></i></span></a>',
            nextArrow:
                '<a class="slick-next"><span class="icon"><i class="fal fa-chevron-right"></i></span></a>',
            mobileFirst: true,
            responsive: [
                {
                    breakpoint: 667,
                    settings: {
                        slidesToShow: 3,
                        slidesToScroll: 1,
                    }
                },
                {
                    breakpoint: 768,
                    settings: {
                        slidesToShow: 3,
                        slidesToScroll: 1
                    }
                },
                {
                    breakpoint: 992,
                    settings: {
                        slidesToShow: 3,
                        slidesToScroll: 3
                    }
                },
                {
                    breakpoint: 1200,
                    settings: {
                        slidesToShow: 4,
                        slidesToScroll: 2
                    }
                },
                {
                    breakpoint: 1440,
                    settings: {
                        slidesToShow: 6,
                        slidesToScroll: 3
                    }
                }
            ]
        });
    });
}

/**
 * 
 * Inner Block - Image Slider
 * 
 */
function inner_block_image_slider() {
    var $sliderContainer = jQuery('.image-slider-container');

    $sliderContainer.each(function (index, item) {
        var $container = jQuery(this),
            $slider = $container.find('.slider').addClass('slider-' + index),
            $controls = $container.find('.slider-controls'),
            $dots = $container.find('.slider-dots'),
            dots = false,
            infinite = true,
            slidesToShow = 1,
            slidesToScroll = 1,
            arrows = false,
            autoplay = false
        ;

        // Arrows //
        if ($container.hasClass('arrows')) {
            arrows = true;

            jQuery('.slider-' + index).on('init reInit afterChange', function (event, slick, currentSlide, nextSlide) {
                var i = (currentSlide ? currentSlide : 0) + 1;
                jQuery('.slide-info', slick.$slider.parent()).html(i + '<span>/</span>' + slick.slideCount);
            });
        }

        // Autoplay //
        if ($container.hasClass('auto')) {
            autoplay = true;
        }
        
        $slider.not('.slick-initialized').slick({
            slidesToShow: slidesToShow,
            slidesToScroll: slidesToScroll,
            dots: dots,
            arrows: arrows,
            autoplay: autoplay,
            infinite: infinite,
            appendDots: $dots,
            appendArrows: $controls,
            autoplaySpeed: 5000,
            prevArrow:
                '<a class="slick-prev"><span class="icon"><i class="fal fa-chevron-left"></i></span></a>',
            nextArrow:
                '<a class="slick-next"><span class="icon"><i class="fal fa-chevron-right"></i></span></a>'
        });
    });
}

/**
 * 
 * Testimonial Block - Slider
 * 
 */
function testimonial_block_slider() {
    var $sliderContainer = jQuery('.testimonial-slider-container');

    $sliderContainer.each(function (index, item) {
        var $container = jQuery(this),
            $slider = $container.find('.slider').addClass('slider-' + index),
            $controls = $container.find('.slider-controls'),
            $dots = $container.find('.slider-dots'),
            dots = false,
            infinite = true,
            slidesToShow = 1,
            slidesToScroll = 1,
            arrows = false,
            autoplay = false
        ;

        // Arrows //
        if ($container.hasClass('arrows')) {
            arrows = true;

            jQuery('.slider-' + index).on('init reInit afterChange', function (event, slick, currentSlide, nextSlide) {
                var i = (currentSlide ? currentSlide : 0) + 1;
                jQuery('.slide-info', slick.$slider.parent()).html(i + '<span>/</span>' + slick.slideCount);
            });
        }

        // Autoplay //
        if ($container.hasClass('auto')) {
            autoplay = true;
        }

        jQuery('.slider-' + index).not('.slick-initialized').slick({
            slidesToShow: slidesToShow,
            slidesToScroll: slidesToScroll,
            dots: dots,
            arrows: arrows,
            autoplay: autoplay,
            infinite: infinite,
            appendDots: $dots,
            appendArrows: $controls,
            autoplaySpeed: 5000,
            prevArrow:
                '<a class="slick-prev"><span class="icon"><i class="fal fa-chevron-left"></i></span></a>',
            nextArrow:
                '<a class="slick-next"><span class="icon"><i class="fal fa-chevron-right"></i></span></a>'
        });
    });
}

/**
 * 
 * Header Hero Slider
 * 
 */
 function content_slider() {
    var $sliderContainer = jQuery('.content-slider');

    $sliderContainer.each(function () {
        var $container = jQuery(this),
            $slider = $container.find('.slider'),
            $controls = $container.find('.slider-controls'),
            $dots = $container.find('.slider-dots'),
            dots = false,
            infinite = true,
            slidesToShow = 1,
            slidesToScroll = 1,
            arrows = true,
            autoplay = false,
            autoplaySpeed = 5000
        ;


        if($container.data('slider-autoplay')) {
            autoplay = true;
        }

        if($container.data('slider-autoplay-speed')) {
            autoplaySpeed = $container.data('slider-autoplay-speed');
        }

        $slider.not('.slick-initialized').slick({
            slidesToShow: slidesToShow,
            slidesToScroll: slidesToScroll,
            dots: dots,
            arrows: arrows,
            autoplay: autoplay,
            infinite: infinite,
            appendDots: $dots,
            appendArrows: $controls,
            autoplaySpeed: autoplaySpeed,
            prevArrow:
                '<a class="slick-prev"><span class="icon"><i class="fal fa-arrow-left"></i></span></a>',
            nextArrow:
                '<a class="slick-next"><span class="icon"><i class="fal fa-arrow-right"></i></span></a>'
        });


        var $counterNumber = $container.find('.slider-controls-count_number');

        $slider.on('beforeChange', function(event, slick, currentSlide,nextSlide ) {
            $counterNumber.text(nextSlide+1);
        });
    });
}